import { render } from "./DatenschutzView.vue?vue&type=template&id=795e2e2e&scoped=true"
import script from "./DatenschutzView.vue?vue&type=script&lang=js"
export * from "./DatenschutzView.vue?vue&type=script&lang=js"

import "./DatenschutzView.vue?vue&type=style&index=0&id=795e2e2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795e2e2e"]])

export default __exports__